export default {
  methods: {
    buildTollsData(rootState, item) {
      let vehicleTripData = {
        metas: rootState.tripMetas,
        tripType: rootState.tripType,
      };

      if (rootState.tripType === 'customtrip') {
        vehicleTripData = rootState.customRouter;
      } else {
        vehicleTripData.origin = rootState.simpleTrip.origin;
        vehicleTripData.destination = rootState.simpleTrip.destination;
        vehicleTripData.is_round_trip = rootState.tripType === 'roundtrip';
      }

      if(!vehicleTripData.metas) {
        vehicleTripData.metas = item.metas
      }
      
      return {
        customerId: rootState.auth.userData.id,
        fleetId: item.selectedVehicle.id,
        originPointId: rootState.cart.cartData.garage,
        source: "erp",
        userId: "1",
        ...(rootState.tripType === 'customtrip'
          ? { customRouter: vehicleTripData }
          : { simpleTrip: vehicleTripData }),
      };
    },
  },
};
